import { createContext } from "react"

const defaultContextValue = {
  currentUser: null,
  isLoading: true,
  error: null,
  refetchUser: async () => {},
}

export const CurrentUserContext = createContext(defaultContextValue)
